import { UserOutlined } from '@ant-design/icons';
import { Col } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import DataCard from 'components/DataCard';
import useRoleCheck from 'hooks/useRoleCheck';
import React from 'react';
import {
  DataCardActionType,
  IDataCardAction,
} from 'routes/Profile/components/ProfileContent/NotaryFileUploadTemplate/types';
import { formatPhoneNumber } from 'utils';

import { AvatarContainerStyled } from '../../styled';
import { ISignatoryInputProps } from '../../types';

const SignatoryCard: React.FC<{
  signatoryData: ISignatoryInputProps;
  onEditClick: (signatoryData: ISignatoryInputProps) => void;
  onDeleteClick?: (signatoryData: ISignatoryInputProps) => void;
}> = ({ signatoryData, onEditClick, onDeleteClick }) => {
  const extraFields = [<span>{signatoryData.email}</span>, <span>{formatPhoneNumber(signatoryData.phone)}</span>];
  const { isClient } = useRoleCheck();
  const action: IDataCardAction = {
    type: DataCardActionType.INTERACT,
    delete: onDeleteClick
      ? () => {
          onDeleteClick(signatoryData);
        }
      : undefined,
  };

  return (
    <Col style={{ marginLeft: 16, marginRight: 16 }}>
      <DataCard
        onClick={() => {
          onEditClick(signatoryData);
        }}
        avatar={
          <AvatarContainerStyled className='gx-pl-3'>
            <Avatar size='large' icon={<UserOutlined />} />
          </AvatarContainerStyled>
        }
        avatarSizes={{ height: '100px' }}
        main={`${signatoryData.firstName} ${signatoryData.lastName}`.toUpperCase()}
        extra={extraFields}
        action={isClient ? action : undefined}
        height='100px'
        width='330px'
        mobileWidth='280px'
        mobileThreshold={480}
      />
    </Col>
  );
};

export default React.memo(SignatoryCard);
